interface Props {
  onClick: () => void;
  label: string;
}

const ReportButton = ({ onClick, label }: Props) => {
  return (
    <button
      onClick={onClick}
      className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium bg-[#1B365D] text-white hover:bg-[#142a4a] transition-colors"
    >
      {label}
    </button>
  );
};

export default ReportButton;
